export default "__VITE_ASSET__DwQQ_llT__"